(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  let busy = false;
  const properties = value => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-cart-remove]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const form = link.closest('[data-safe-cart]');
    const error = form.querySelector('[data-cart-error]');
    error.hidden = true;
    form.setAttribute('aria-busy', 'true');
    const buttons = [...form.querySelectorAll('button')];
    buttons.forEach(button => button.disabled = true);
    try {
      const response = await fetch(form.action + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      let item = cart.items.find(item => item.key === link.dataset.key);
      if (!item) {
        const matches = cart.items.filter(item => String(item.variant_id) === link.dataset.variant
          && properties(item.properties) === properties(JSON.parse(link.dataset.properties))
          && String(item.selling_plan_allocation?.selling_plan?.id || '') === link.dataset.plan);
        if (matches.length !== 1) {
          window.location.assign(form.action);
          return;
        }
        item = matches[0];
      }
      const changed = await fetch(form.dataset.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
      if (!changed.ok) throw new Error('Removal failed');
      window.location.assign(form.action);
    } catch (failure) {
      error.hidden = false;
      error.scrollIntoView({ block: 'nearest' });
      form.removeAttribute('aria-busy');
      buttons.forEach(button => button.disabled = false);
      busy = false;
    }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && document.querySelector('[data-safe-cart]')) window.location.reload();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
